const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.FacilityServiceSimpleClient =
  function FacilityServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.listBarns = this.listBarns.bind(this);
    this.getBarn = this.getBarn.bind(this);
    this.getFacility = this.getFacility.bind(this);
    this.listFacilities = this.listFacilities.bind(this);
    this.editFacilityInfo = this.editFacilityInfo.bind(this);
    this.listCourses = this.listCourses.bind(this);
    this.editCurrentTrackCondition = this.editCurrentTrackCondition.bind(this);
  };
const methodInfo_FacilityService_ListBarns = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.FacilityService/ListBarns",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListBarnsRequest,
  imports.stronachgroup.first.racehorse360.ListBarnsResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListBarnsResponse.decode
);
module.exports.FacilityServiceSimpleClient.prototype.listBarns = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListBarnsRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.FacilityService/ListBarns",
    message,
    metadata || {},
    methodInfo_FacilityService_ListBarns
  );
};
const methodInfo_FacilityService_GetBarn = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.FacilityService/GetBarn",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.GetBarnRequest,
  imports.stronachgroup.first.racehorse360.Barn,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.Barn.decode
);
module.exports.FacilityServiceSimpleClient.prototype.getBarn = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.GetBarnRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.FacilityService/GetBarn",
    message,
    metadata || {},
    methodInfo_FacilityService_GetBarn
  );
};
const methodInfo_FacilityService_GetFacility = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.FacilityService/GetFacility",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.GetFacilityRequest,
  imports.stronachgroup.first.racehorse360.Facility,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.Facility.decode
);
module.exports.FacilityServiceSimpleClient.prototype.getFacility = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.GetFacilityRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.FacilityService/GetFacility",
    message,
    metadata || {},
    methodInfo_FacilityService_GetFacility
  );
};
const methodInfo_FacilityService_ListFacilities = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.FacilityService/ListFacilities",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListFacilitiesRequest,
  imports.stronachgroup.first.racehorse360.ListFacilitiesResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListFacilitiesResponse.decode
);
module.exports.FacilityServiceSimpleClient.prototype.listFacilities = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListFacilitiesRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.FacilityService/ListFacilities",
    message,
    metadata || {},
    methodInfo_FacilityService_ListFacilities
  );
};
const methodInfo_FacilityService_EditFacilityInfo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityService/EditFacilityInfo",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.EditFacilityInfoRequest,
    imports.stronachgroup.first.racehorse360.Facility,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Facility.decode
  );
module.exports.FacilityServiceSimpleClient.prototype.editFacilityInfo =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.EditFacilityInfoRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/EditFacilityInfo",
      message,
      metadata || {},
      methodInfo_FacilityService_EditFacilityInfo
    );
  };
const methodInfo_FacilityService_ListCourses = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.FacilityService/ListCourses",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListCoursesRequest,
  imports.stronachgroup.first.racehorse360.ListCoursesResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListCoursesResponse.decode
);
module.exports.FacilityServiceSimpleClient.prototype.listCourses = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListCoursesRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.FacilityService/ListCourses",
    message,
    metadata || {},
    methodInfo_FacilityService_ListCourses
  );
};
const methodInfo_FacilityService_EditCurrentTrackCondition =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityService/EditCurrentTrackCondition",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest,
    imports.stronachgroup.first.racehorse360.Course,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Course.decode
  );
module.exports.FacilityServiceSimpleClient.prototype.editCurrentTrackCondition =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityService/EditCurrentTrackCondition",
      message,
      metadata || {},
      methodInfo_FacilityService_EditCurrentTrackCondition
    );
  };
